import { render, staticRenderFns } from "./CategoryEditModal.vue?vue&type=template&id=243000a3&scoped=true"
import script from "./CategoryEditModal.vue?vue&type=script&lang=js"
export * from "./CategoryEditModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditModal.vue?vue&type=style&index=0&id=243000a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243000a3",
  null
  
)

export default component.exports